/**
 * The sentence to show when an API call is refused: the server's own reason
 * (its `{ error: "..." }` body) when it gives one, else the caller's fallback.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const reason = (err as { response?: { data?: { error?: unknown } } } | null)?.response?.data?.error;
  return typeof reason === 'string' && reason.trim() ? reason : fallback;
}
